import styled from 'styled-components'
import { color } from '../../GlobalStyle'

export const FullLogin = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  justify-content: center;
  align-items: center;
  background: linear-gradient(
    to bottom,
    #38d35c 35%,
    ${({ theme }) => theme.background_secundary} 30%
  );

  footer {
    position: absolute;
    bottom: 20px;
  }
`
export const Logo = styled.div`
  position: absolute;
  top: 3px;
  padding: 5px;
  left: 3px;
`
export const LoginContainer = styled.form`
  z-index: 3;
  background-color: ${({ theme }) => theme.background};
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  min-width: 210px;
  max-width: 350px;
  margin: 10px;
  width: 100%;
  -webkit-box-shadow: 0 0 40px rgb(8 21 66 / 15%);
  padding: 35px;
  justify-items: center;
`
export const Infos = styled.div`
  margin-bottom: 1.9vh;
  margin: 0 auto;
  text-align: center;
  svg {
    margin-bottom: 12px;
    font-size: 75px;
    color: ${color.brand};
  }
  h2 {
    font-size: 30px;
  }
  p {
    color: rgba(0, 0, 0, 0.7);
    margin-top: 11px;
    margin-bottom: 12px;
    font-size: 0.8rem;
  }
`
export const Title = styled.p``
export const InputContainer = styled.div`
  position: relative;
  color: #fff;
  display: flex;
  padding: 10px 0;
`
export const NewUser = styled.div`
  width: 100%;
  margin: 0 auto;
`

export const IconInput = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  background-color: ${color.brand};
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  font-size: 15px;
`

export const NewPassword = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: column;
  align-items: flex-end;
`

export const TextUser = styled.p`
  color: ${color.brand};
  font-weight: bold;
  margin: 0.5vh;
  font-size: 11px;
`
